import { createAppTranslation } from '@fiverr-private/i18n-react';
import copies from '../copies.json';

export const { AppI18n, appTranslate } = createAppTranslation(copies, 'header');

export type CopyKey = Parameters<typeof appTranslate>[0];
